document.addEventListener('DOMContentLoaded', function () {
  // Product page: swap main image on thumbnail click
  document.querySelectorAll('.product-thumbs').forEach(function (thumbs) {
    var mainImg = thumbs.closest('.product-media').querySelector('img.product-main-image');
    thumbs.querySelectorAll('.thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImg && thumb.dataset.full) mainImg.src = thumb.dataset.full;
      });
    });
  });

  // Product page: keep the hidden variant id input in sync with option selects
  document.querySelectorAll('.product-form').forEach(function (form) {
    var variantsEl = document.getElementById(form.dataset.variantsId);
    if (!variantsEl) return;
    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('select[name^="options"]');
    var hiddenId = form.querySelector('input[name="id"]');
    if (!selects.length || !hiddenId) return;

    function updateVariant() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(Boolean);
        return chosen.every(function (val, i) { return opts[i] === val; });
      });
      if (match) hiddenId.value = match.id;
    }
    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });
  });
});
